import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { adminUpdateUserApi } from 'redux/actions/adminPtPlus/index';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import { Field } from 'formik'
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import Select from 'web/components/form-elements/Select';
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";

import AlertModal from 'web/components/AlertModal';

function FeeType(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [saveDisableState, setSaveDisableState] = useState(true)
    const [accordionOpen, setAccordionOpen] = useState(false)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    let pageFieldValues = pageProps.formikProps.values

    let feeTypeList = [{ value: "PERCENTAGE", label: 'Percentage' },
    { value: "COSTPERPALLET", label: 'Cost Per Pallet' }]
    let currencyList = [{ value: "USD", label: 'USD' }]

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        if ((fieldValues.feeTypeRadio === 'PERCENTAGE' && fieldValues.percentageValue !== '' || fieldValues.feeTypeRadio === 'COSTPERPALLET' && fieldValues.costPerPalletValue !== '')) {
            setSaveDisableState(false)
        } else setSaveDisableState(true)
    }, [pageProps.formikProps])

    const updateApiFunction = async () => {
        let id = pageProps.pageData.id
        let url = `ptms/internal/fee_structure_update/${id}`
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            feeType: fieldValues.feeTypeRadio,
        }
        if (fieldValues.feeTypeRadio === 'PERCENTAGE') {
            data.feeTypePercentage = {
                fee: fieldValues.percentageValue,
                currency: "USD"
            }
            data.feeTypeCostPallet = null
        } else {
            data.feeTypePercentage = null
            data.feeTypeCostPallet = {
                fee: fieldValues.costPerPalletValue,
                currency: "USD"
            }
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminUpdateUserApi(url, data, token))
        if (response.success) {
            setAlertModalContent('Detail has been updated successfully.')
            setAlertModal(!alertModal)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    const resetFieldsFunction = () => {
        const initailData = pageProps.pageData
        pageProps.setFieldValue('feeTypeRadio', initailData.feeStructure?.feeType)
        pageProps.setFieldValue('percentageValue', initailData.feeStructure?.feeTypePercentage?.fee)
        pageProps.setFieldValue('costPerPalletValue', initailData.feeStructure?.feeTypeCostPallet?.fee)
    }

    return (
        <>
            <Container>
                <AccordionHeader>
                    <h6 onClick={() => {
                        if(accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Fee Type</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader>
                {accordionOpen &&
                    <AccordionBody>
                        <InputFieldsWrapper>
                            <div className="row">
                                {feeTypeList.map((value, index) => (
                                    <div className="col-md-4">
                                        <div key={index}>
                                            <Field
                                                component={RadioButton}
                                                name="feeTypeRadio"
                                                id={value.value}
                                                defaultValue={feeTypeList[0].value}
                                                onSelect={(e) => {
                                                    if (e.target.value === "PERCENTAGE") {
                                                        pageProps.setFieldValue("costPerPalletValue","")
                                                    }else{
                                                        pageProps.setFieldValue("percentageValue","")
                                                    }
                                                }}
                                                label={value.label}
                                            />
                                        </div>
                                        <div className="row flatType">
                                            <div className="col-md-6 bordered-input">
                                                <NumberInput
                                                    disabled={pageProps.formikProps.values.feeTypeRadio === 'PERCENTAGE' ?
                                                        (value.value === 'PERCENTAGE' ? false : true) :
                                                        pageProps.formikProps.values.feeTypeRadio === 'COSTPERPALLET' &&
                                                        (value.value === 'COSTPERPALLET' ? false : true)
                                                    }
                                                    name={value.value === 'PERCENTAGE' ? 'percentageValue' : 'costPerPalletValue'} decimalScale={2} placeholder={value.value === 'PERCENTAGE' ?'0.00%':'$0.00'} />
                                            </div>
                                            <div className="col-md-6">
                                                <Select
                                                    name={value.value === 'PERCENTAGE' ? 'percentageCurrencyLists' : 'costPerPalletCurrencyLists'}
                                                    data={currencyList}
                                                    disabled
                                                    onChangeHandler={() => {
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </InputFieldsWrapper>
                        <div className='view-edit-button-section'>
                            <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div>
                    </AccordionBody>
                }
            </Container>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )
}

export default FeeType